module.exports = __webpack_public_path__ + "media/images/icons/three-dot-white-icon-ebf11bf3f6fc34f70f38890208066d09.svg";